import React from 'react'

function PageHeading() {
  return (
    <div>
        <div className="page-heading header-text">
    <div className="container">
      <div className="row">
        <div className="col-lg-12">
          <span className="breadcrumb"><a href="#">Home</a> / Properties</span>
          <h3>Properties</h3>
        </div>
      </div>
    </div>
  </div>
    </div>
  )
}

export default PageHeading